import axios from "axios";
import {settings} from "../config";
import {getTokenService} from "./useTokenService";

export const sendDeleteQuery = async (deleteItem: any,user:any)=>{
    let {token} = getTokenService({user:user})
    await axios.post(settings.baseUrl + 'AdminBidList/RemoveBid/' + deleteItem.BidId,{},{ headers:{"Authorization":"Bearer " + token()}})
};